import React, { useEffect, useState } from 'react';
import { FaEye, FaPencilAlt, FaRegPlusSquare, FaRegSave, FaRegTrashAlt } from 'react-icons/fa';

const ActionButton = ({ type, action }) => {
    const [button, setButton] = useState();
    useEffect(() => {
        switch (type) {
            case 'delete':
                setButton(<FaRegTrashAlt />);
                break;
            case 'edit':
                setButton(<FaPencilAlt />);
                break;
            case 'add':
                setButton(<FaRegPlusSquare />);
                break;
            case 'save':
                setButton(<FaRegSave />);
                break;
            case 'see':
                setButton(<FaEye />);
                break;
            default:
                break;
        }
    }, [type]);

    return (
        <button className={ `action-button ${type}` } onClick={ action }>
            { button }
        </button>
    );
};

export default ActionButton;